const images = {
  profile: require('./images/profile.PNG'),
  twist: require('./images/twist.png'),
  fireapp: require('./images/fireapp.png'),
  iPhone17ProMax: require('./images/iPhone17ProMax.png'),
  arc: require('./images/arc.png'),
  ejada: require('./images/ejada.png'),
  arc_logo: require('./images/arc_logo.png'),
  etisalat: require('./images/etisalat.webp'),
  pharaoh: require('./images/pharaoh.webp'),
  freelance: require('./images/freelance.png'),
  twistLogo: require('./images/twistlogo.png'),
  warshatna: require('./images/warshtna.png'),
  fireApp: require('./images/local935.jpg'),
  rotary: require('./images/rotary.png'),
  priceShare: require('./images/priceshare.png'),
};

export const ASSETS = {
  images,
};
